import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import Loading from "../general/Loading";
import Swal from 'sweetalert2';
import DataTable from "react-data-table-component";

function UsuariosSispro() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const [items, setItems] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [tienePermiso, setTienePermiso] = useState(false);
    const [terminoBusqueda, setTerminoBusqueda] = useState('');
    const [idItemEliminar, setIdItemEliminar] = useState();
    const [modalContainerStatus, setModalContainerStatus] = useState('');
    const [modalBackdropStatus, setModalBackdropStatus] = useState('zindex-back');
    const [toastMsg, setToastMsg] = useState('');
    let userdata = [];

    const cols = [
        { name: 'Nombre', selector: row => row.nombre, sortable: true },
        { name: 'Tipo Doc.', selector: row => row.tipo_documento, sortable: true },
        { name: 'Identificación', selector: row => row.identificacion, sortable: true },
        { name: 'Usuario Responsable', selector: row => getNombreUsuario(row.users_id), sortable: true },
        { name: 'Estado', cell: row => getEstadoBadge(row), sortable: true },
        { name: 'Acción', cell: row => getBotones(row), minWidth: '20%' }
    ];

    const getBotones = (item) => {
        return (
            <>
                <Link 
                    to={'/editar-usuario-sispro?id=' + item.id} 
                    className="btn btn-info btn-sm"
                    style={{ pointerEvents: tienePermiso ? 'auto' : 'none', opacity: tienePermiso ? 1 : 0.5 }}
                    title={!tienePermiso ? 'No tiene permisos para editar' : 'Editar'}
                >
                    <i className="far fa-edit"></i>&nbsp;Editar
                </Link>&nbsp;
                <button
                    onClick={() => showModal(item.id, item.nombre)}
                    className="btn btn-outline-danger btn-sm"
                    disabled={!tienePermiso}
                    style={{ opacity: tienePermiso ? 1 : 0.5 }}
                    title={!tienePermiso ? 'No tiene permisos para eliminar' : 'Eliminar'}
                >
                    <i className="fas fa-trash-alt"></i>&nbsp;Eliminar
                </button>
            </>
        );
    };

    const getEstadoBadge = (item) => {
        return (
            <span 
                className={`badge ${item.activo === 1 ? 'badge-success' : 'badge-secondary'}`}
                style={{
                    cursor: tienePermiso ? 'pointer' : 'default',
                    opacity: tienePermiso ? 1 : 0.7
                }}
                onClick={() => tienePermiso && toggleActivo(item.id, item.activo)}
                title={tienePermiso ? 'Click para cambiar estado' : 'No tiene permisos para cambiar estado'}
            >
                {item.activo === 1 ? 'Activo' : 'Inactivo'}
            </span>
        );
    };

    useEffect(() => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        // 🔐 Validación simple de permisos (solo deshabilita botones, no bloquea acceso)
        let permiso = false;
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            permiso = userdata.permissions.some(permission => permission.slug === 'gestionarUsuariosSispro');
        } else if (userdata.up && userdata.up.includes('gestionarUsuariosSispro')) {
            permiso = true;
        }
        setTienePermiso(permiso);

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        // Obtener datos del cliente
        axios.get('/get-client?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('Error:', error);
            });

        // Cargar usuarios SISPRO
        axios.get('/sispro-users?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    console.log('✅ Usuarios SISPRO cargados:', response.data);
                    setItems(response.data);
                }
            })
            .catch(error => {
                console.error('❌ Error al cargar usuarios SISPRO:', error);
            });

        // Cargar usuarios del cliente
        axios.get('/usuarios?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('Error al cargar usuarios:', error);
            });
    }, []);

    useEffect(() => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                uid: userdata.user_id,
                termino: terminoBusqueda
            }
        };

        axios.get('/sispro-users', config)
            .then(response => {
                setItems(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, [terminoBusqueda]);

    const getNombreUsuario = (usersId) => {
        if (!usersId) return '-';
        const usuario = usuarios.find(u => u.id === usersId);
        return usuario ? `${usuario.name} ${usuario.lastname}` : '-';
    };

    const showModal = (id, nombre) => {
        setModalContainerStatus('show');
        setModalBackdropStatus('show');
        setIdItemEliminar(id);
    };

    const cerrar = () => {
        setModalContainerStatus('');
        setModalBackdropStatus('zindex-back');
        setIdItemEliminar(null);
    };

    const eliminar = (id) => {
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            },
            params: {
                id: id
            }
        };

        axios.delete('/sispro-user?uid=' + userdata.user_id, config)
            .then(response => {
                if (response.status === 200) {
                    const nuevoItems = items.filter((it) => it.id !== id);
                    const eliminado = items.find((it) => it.id === id);
                    setItems(nuevoItems);
                    cerrar();
                    setToastMsg('El Usuario SISPRO ' + (eliminado ? eliminado.nombre : '') + ' Se Eliminó Con ÉXITO');
                }
            })
            .catch(error => {
                console.log(error);
                cerrar();
            });
    };

    const toggleActivo = (id, activoActual) => {
        const nuevoEstado = activoActual === 1 ? 0 : 1;

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        };

        axios.put('/sispro-user/' + id, { activo: nuevoEstado }, config)
            .then(response => {
                // Actualizar el item en el estado
                const nuevosItems = items.map(item => {
                    if (item.id === id) {
                        return { ...item, activo: nuevoEstado };
                    }
                    return item;
                });
                setItems(nuevosItems);
                setToastMsg(`Usuario SISPRO ${nuevoEstado === 1 ? 'activado' : 'desactivado'} exitosamente`);
            })
            .catch(error => {
                console.error('Error al cambiar estado:', error);
            });
    };

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item"><Link to="/personal-proveedores">Personal y Proveedores</Link></li>
                                        <li className="breadcrumb-item active">Usuarios SISPRO</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Usuarios SISPRO</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row" style={{marginBottom: '30px'}}>
                                <div className="col-md-9">
                                    <Link 
                                        to="/nuevo-usuario-sispro" 
                                        className="btn btn-primary"
                                        style={{ pointerEvents: tienePermiso ? 'auto' : 'none', opacity: tienePermiso ? 1 : 0.5 }}
                                        title={!tienePermiso ? 'No tiene permisos para crear usuarios SISPRO' : ''}
                                    >
                                        Crear Nuevo Usuario SISPRO
                                    </Link>
                                </div>
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label htmlFor="terminoBusqueda">Buscar</label>
                                        <input 
                                            type="text" 
                                            name="terminoBusqueda" 
                                            className="form-control" 
                                            id="terminoBusqueda" 
                                            onChange={(e) => setTerminoBusqueda(e.target.value)} 
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <DataTable
                                        columns={cols}
                                        data={items}
                                        pagination
                                        paginationComponentOptions={{
                                            rowsPerPageText: 'Filas por página:',
                                            rangeSeparatorText: 'de',
                                            noRowsPerPage: false,
                                            selectAllRowsItem: true,
                                            selectAllRowsItemText: 'Todos'
                                        }}
                                        noDataComponent="No hay registros para mostrar"
                                        id={'usuarios_sispro'}
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <div className={'modal-container modal fade in ' + modalContainerStatus}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title">Eliminar Usuario SISPRO</h4>
                                <button type="button" className="close" onClick={() => cerrar()}>&times;</button>
                            </div>
                            <div className="modal-body">
                                ¿Está Seguro Que Desea Eliminar El Usuario SISPRO Seleccionado?
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => cerrar()}>Cancelar</button>
                                <button type="button" className="btn btn-danger" onClick={() => eliminar(idItemEliminar)}>Eliminar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={'modal-backdrop fade ' + modalBackdropStatus}></div>

                <Footer showToast={false} delay={0} message={toastMsg} />
            </div>
        );
    }

    return <Loading />;
}

export default UsuariosSispro;
